import { FlexBox } from 'shared/components/Base/FlexBox'
import { ProductSubscriptionItemStatus } from 'shared/models/productSubscription'
import { blueGray, lightgreye3, midGray } from 'shared/theme/colors'
import { header4 } from 'shared/theme/typography'
import styled, { css } from 'styled-components'

import { CTINLLCMCNumber } from 'helpers/constants'
import { Team } from 'models/team'
import ErrorIconFilled from '../../assets/images/ErrorIconFilledSmall.svg'
import PendingIconFilled from '../../assets/images/PendingIconFilledSmall.svg'

interface Entitlement {
  name: string
  status: ProductSubscriptionItemStatus
}

interface TeamEntitlementsProps {
  entitlements?: Entitlement[]
  team: Team
}

export function TeamEntitlements(props: TeamEntitlementsProps) {
  if (!props.entitlements) return null

  const sortedEntitlements = [...props.entitlements].sort((e) =>
    e.status === ProductSubscriptionItemStatus.ACTIVE ? -1 : 1
  )

  return (
    <FlexBox gap="10px">
      {sortedEntitlements.map((entitlement) => (
        <TeamEntitlement key={entitlement.name} entitlement={entitlement} team={props.team} />
      ))}
    </FlexBox>
  )
}

export function TeamEntitlement({ entitlement, team }: { entitlement: Entitlement; team: Team }) {
  function getIconName() {
    if (entitlement.status === ProductSubscriptionItemStatus.REMOVED) return ErrorIconFilled
    if (entitlement.status === ProductSubscriptionItemStatus.OFFBOARDING) return ErrorIconFilled
    return PendingIconFilled
  }

  function renderStatus() {
    if (entitlement.status === ProductSubscriptionItemStatus.ACTIVE) return null
    return <img src={getIconName()} alt="" width="16px" style={{ margin: '-3px 0 0 -5px' }} />
  }

  const ctMcNumber = team?.product_subscription?.ct_mc_number || team?.ct_mc_number
  const carrier = team?.product_subscription?.carrier || team?.carrier
  const entitlementName = carrier ? `${carrier.name} - MC ${carrier.mc_number}` : entitlement.name

  return (
    <Pill
      $lightBg={[
        ProductSubscriptionItemStatus.REMOVED,
        ProductSubscriptionItemStatus.OFFBOARDING,
        ProductSubscriptionItemStatus.PENDING,
      ].includes(entitlement.status)}
      $isCtIn={ctMcNumber === CTINLLCMCNumber}
    >
      {renderStatus()}
      {entitlementName}
    </Pill>
  )
}

const Pill = styled.div<{ $lightBg: boolean; $isCtIn: boolean }>`
  display: flex;
  align-items: center;
  padding: 5px 10px 3px;
  gap: 5px;
  background: ${midGray};
  border-radius: 31px;
  ${header4};
  font-size: 12px;
  color: #ffffff;

  ${(p) =>
    p.$lightBg &&
    css`
      background: ${blueGray};
    `}
  ${(p) =>
    p.$isCtIn &&
    css`
      color: ${midGray};
      background: ${lightgreye3};
      border: 1px solid ${midGray};
    `}
`
